module.exports = __webpack_public_path__ + "img/hovered-layer3.02ca508d.png";